export default "__VITE_ASSET__ksoqc03I__"